import { useState } from 'react';
import { useHistory } from 'react-router-dom';

import Reducer from '../../modules/reducers/Reducer';
import TEXT from '../../lib/text/textSalesBabyface.json';

const useBabyfaceOptions = ({ babyface, isActiveCampaigns }) => {
  const history = useHistory();

  const [isShowPriceInfo, setIsShowPriceInfo] = useState(false);
  const [isShowDrawer, setIsShowDrawer] = useState(false);
  const [purchaseType, setPurchaseType] = useState({
    path: '',
    title: '',
    guide: null,
  });
  const [optionsValue, setOptionsValue, , setAllOptionsValue] = Reducer(
    OPTIONS_INITIAL_STATE,
  );
  const {
    conversionOption,
    printOption,
    additionalOption,
    conversionPrice,
    printPrice,
    additionalPrice,
  } = optionsValue;

  const babyfaceDefaultPrice = babyface.price;
  const babyfacePrice = isActiveCampaigns ? babyface.eventPrice : babyface.price;
  
  // 세션에서 쿠폰 코드 배열 가져오기
  const getPreSelectedVoucherCodes = () => {
    const preSelectedVoucherCodes = sessionStorage.preSelectedVoucherCodes;
    if (preSelectedVoucherCodes) {
      try {
        return JSON.parse(preSelectedVoucherCodes);
      } catch (e) {
        return [];
      }
    }
    const preSelectedVoucherCode = sessionStorage.preSelectedVoucherCode;
    return preSelectedVoucherCode ? [preSelectedVoucherCode] : [];
  };
  
  const preSelectedVoucherCodes = getPreSelectedVoucherCodes();
  const hasFastCoupon = preSelectedVoucherCodes.some(code => 
    code && code.startsWith('HE_DISCOUNT_') && code.endsWith('_FAST')
  );
  
  // 빠른 분석 옵션인지 확인 (옵션 이름에 "빠른" 또는 "24시간"이 포함되어 있는지 확인)
  const isFastAnalysisOption = conversionOption && (
    conversionOption.name.includes('빠른') || 
    conversionOption.name.includes('24시간') ||
    conversionOption.name.toLowerCase().includes('fast')
  );
  
  // 빠른 분석 할인 금액 (4,500원) - 빠른 분석 쿠폰이 있고 빠른 분석 옵션을 선택했으면 추가 할인 적용
  const fastAnalysisDiscount = hasFastCoupon && isFastAnalysisOption ? 4500 : 0;
  
  const productPrice = babyfacePrice + conversionPrice + printPrice + additionalPrice - fastAnalysisDiscount;
  
  // 배송비 무료 쿠폰이 있으면 배송비 0으로 처리
  const baseShippingPrice = printOption !== null && printOption.shipmentRequired ? printOption.shippingFee : 0;
  const shippingPrice = babyface.freeShipping && baseShippingPrice > 0 ? 0 : baseShippingPrice;
  
  // 배송비 무료 쿠폰이 있고 배송비가 있으면 activeCampaigns에 배송비 무료 혜택 추가
  const activeCampaigns = babyface.activeCampaigns || [];
  const freeShippingCampaign = babyface.freeShipping && baseShippingPrice > 0 
    ? [{ description: '배송비 무료', discountAmount: baseShippingPrice }]
    : [];
  
  // 빠른 분석 옵션 선택 시 HE_DISCOUNT_*_FAST 쿠폰이 있으면 혜택 표시
  const fastAnalysisCampaign = hasFastCoupon && isFastAnalysisOption
    ? [{ description: '빠른 분석 4,500원 할인', discountAmount: 4500 }]
    : [];
  
  const finalActiveCampaigns = [...activeCampaigns, ...freeShippingCampaign, ...fastAnalysisCampaign];
  
  console.log('빠른 분석 쿠폰 체크:', {
    hasFastCoupon,
    isFastAnalysisOption,
    conversionOptionName: conversionOption && conversionOption.name,
    fastAnalysisDiscount,
    babyfacePrice,
    productPrice,
    preSelectedVoucherCodes
  });
  
  console.log('최종 activeCampaigns:', {
    finalActiveCampaigns,
    activeCampaigns,
    freeShippingCampaign,
    fastAnalysisCampaign
  });

  const doSelectConversionOption = (e) => {
    setAllOptionsValue({
      object: { conversionOption: e, conversionPrice: e.price },
    });
  };

  const doDeleteConversionOption = () => {
    setAllOptionsValue({
      object: { conversionOption: null, conversionPrice: 0 },
    });
  };

  const doSelectPrintOption = (e) => {
    setAllOptionsValue({
      object: { printOption: e, printPrice: e.price },
    });

    if ((e === null || !e.shipmentRequired) && additionalOption.length > 0) {
      window.alert('인화 및 배송을 선택하셔야 추가상품을 구매 하실 수 있습니다.');
      setAllOptionsValue({
        object: {
          additionalOption: [],
          additionalPrice: 0,
        },
      });
    }
  };

  const doDeletePrintOption = () => {
    setAllOptionsValue({
      object: { printOption: null, printPrice: 0 },
    });

    if (additionalOption.length > 0) {
      window.alert('인화 및 배송을 선택하셔야 추가상품을 구매 하실 수 있습니다.');
      setAllOptionsValue({
        object: {
          additionalOption: [],
          additionalPrice: 0,
        },
      });
    }
  };

  const doSelectAdditionalOption = (e) => {
    if (printOption === null || !printOption.shipmentRequired) {
      window.alert('인화 및 배송을 선택하셔야 추가상품을 구매 하실 수 있습니다.');
      return;
    }
    setAllOptionsValue({
      object: {
        additionalOption: additionalOption.concat(e),
        additionalPrice: additionalPrice + e.price,
      },
    });
  };

  const doDeleteAdditionalOption = ({ id, price }) => {
    const deleteIndex = additionalOption.findIndex((item) => item.id === id);
    additionalOption.splice(deleteIndex, 1);
    setOptionsValue({
      name: 'additionalPrice',
      value: additionalPrice - price,
    });
  };

  const doShowPurchaseDrawer = ({ path, title, guide }) => {
    setIsShowDrawer(true);
    setPurchaseType({ ...purchaseType, path, title, guide });
  };

  const doPurchase = () => {
    if (conversionOption === null) {
      return alert(
        additionalOption.length < 1
          ? alertNoPurchaseOption
          : alertNoConversionOption,
      );
    }

    if (printOption === null) {
      return alert(alertNoPrintOption);
    }

    sessionStorage.optionIds = JSON.stringify(
      [conversionOption.id, printOption.id].concat(additionalOption.map((item) => item.id)),
    );

    history.push(purchaseType.path);
  };

  const doGetOrderPrices = () => {
    // 배송비 무료 쿠폰이 있을 때 원래 배송비와 할인된 배송비 정보 반환
    const hasShippingFee = printOption !== null && printOption.shipmentRequired && printOption.shippingFee > 0;
    const isFreeShipping = babyface.freeShipping && hasShippingFee && shippingPrice === 0;
    
    return [
      { 
        title: textProductPrice, 
        price: productPrice.toLocaleString(),
        originalPrice: null,
        isDiscounted: false
      },
      { 
        title: textShippingFee, 
        price: shippingPrice === 0 ? '0' : `+${shippingPrice.toLocaleString()}`,
        originalPrice: isFreeShipping ? `+${baseShippingPrice.toLocaleString()}` : null,
        isDiscounted: isFreeShipping
      },
    ];
  };

  // 빠른 분석 할인이 적용된 babyfacePrice (옵션 표시용)
  const babyfacePriceWithFastDiscount = isFastAnalysisOption && hasFastCoupon 
    ? babyfacePrice - fastAnalysisDiscount 
    : babyfacePrice;

  return {
    babyfaceDefaultPrice,
    babyfacePrice,
    babyfacePriceWithFastDiscount,
    fastAnalysisDiscount,
    activeCampaigns: finalActiveCampaigns,
    isShowDrawer,
    setIsShowDrawer,
    isShowPriceInfo,
    setIsShowPriceInfo,
    conversionOption,
    printOption,
    additionalOption,
    productPrice,
    shippingPrice,
    purchaseType,
    doSelectConversionOption,
    doDeleteConversionOption,
    doSelectPrintOption,
    doDeletePrintOption,
    doSelectAdditionalOption,
    doDeleteAdditionalOption,
    doShowPurchaseDrawer,
    doPurchase,
    doGetOrderPrices,
  };
};

export default useBabyfaceOptions;

const OPTIONS_INITIAL_STATE = {
  conversionOption: null,
  printOption: null,
  additionalOption: [],
  conversionPrice: 0,
  printPrice: 0,
  additionalPrice: 0,
};

const {
  alertNoPurchaseOption,
  alertNoConversionOption,
  alertNoPrintOption,
  textProductPrice,
  textShippingFee,
} = TEXT;
